import React from 'react'

export default function DriverPrivacy() {
  return (
  <>
   <section className="bg-trogoBg min-h-screen py-16">
      <div className="max-w-5xl mx-auto px-4 mt-3">

        {/* Heading */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-trogoBlue">
            Driver Privacy Policy
          </h1>

          <div className="w-24 h-1 bg-trogoOrange mx-auto mt-4 rounded-full"></div>

          <p className="text-gray-600 mt-4 text-lg">
            Your privacy and data security are important to us at TROGO.
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-white shadow-lg rounded-2xl p-8 md:p-10 space-y-8">

          {/* Section 1 */}
          <div>
            <h2 className="text-2xl font-semibold text-trogoBlue mb-3">
              1. Information We Collect
            </h2>

            <p className="text-gray-700 leading-relaxed">
              TROGO collects personal and vehicle-related information from
              drivers and transporters to provide safe and reliable services.
              This may include:
            </p>

            <ul className="mt-4 space-y-2 text-gray-700">
              <li>• Full Name & Contact Details</li>
              <li>• Aadhaar Card Information</li>
              <li>• Driving License Details</li>
              <li>• Vehicle RC & Insurance Documents</li>
              <li>• Location & Ride Activity Data</li>
              <li>• Payment & Bank Details</li>
            </ul>
          </div>

          {/* Section 2 */}
          <div>
            <h2 className="text-2xl font-semibold text-trogoBlue mb-3">
              2. How We Use Your Information
            </h2>

            <p className="text-gray-700 leading-relaxed">
              The information collected is used to:
            </p>

            <ul className="mt-4 space-y-2 text-gray-700">
              <li>• Verify drivers and vehicles</li>
              <li>• Process bookings and payments</li>
              <li>• Improve platform safety and reliability</li>
              <li>• Provide customer support</li>
              <li>• Prevent fraud and unauthorized activities</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div>
            <h2 className="text-2xl font-semibold text-trogoBlue mb-3">
              3. Data Security
            </h2>

            <p className="text-gray-700 leading-relaxed">
              TROGO uses secure systems and industry-standard protection
              measures to keep your personal information safe and protected
              from unauthorized access.
            </p>
          </div>

          {/* Section 4 */}
          <div>
            <h2 className="text-2xl font-semibold text-trogoBlue mb-3">
              4. Sharing of Information
            </h2>

            <p className="text-gray-700 leading-relaxed">
              TROGO does not sell personal information to third parties.
              Information may only be shared with:
            </p>

            <ul className="mt-4 space-y-2 text-gray-700">
              <li>• Government or legal authorities when required</li>
              <li>• Payment service providers</li>
              <li>• Customers for booking-related communication</li>
            </ul>
          </div>

          {/* Section 5 */}
          <div>
            <h2 className="text-2xl font-semibold text-trogoBlue mb-3">
              5. Driver Responsibilities
            </h2>

            <p className="text-gray-700 leading-relaxed">
              Drivers are responsible for providing accurate and updated
              documents and maintaining confidentiality of their account
              credentials.
            </p>
          </div>

          {/* Section 6 */}
          <div>
            <h2 className="text-2xl font-semibold text-trogoBlue mb-3">
              6. Policy Updates
            </h2>

            <p className="text-gray-700 leading-relaxed">
              TROGO may update this Privacy Policy periodically to reflect
              changes in legal requirements or platform services.
            </p>
          </div>

          {/* Section 7 */}
          <div>
            <h2 className="text-2xl font-semibold text-trogoBlue mb-3">
              7. Contact Us
            </h2>

            <p className="text-gray-700 leading-relaxed">
              If you have any questions regarding this Privacy Policy,
              please contact us:
            </p>

            <div className="mt-4 space-y-2 text-gray-700">
              <p>
                📧 Email:{" "}
                <span className="text-trogoOrange font-medium">
                   info@togoodsdraft.com
                </span>
              </p>

              <p>
                📞 Phone:{" "}
                <span className="text-trogoOrange font-medium">
                  +91 9552396672
                </span>
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  
  </>
  )
}
